<template>
    <span>
      <b-link style="color: #2B5FCB;" @click="editPlan">Edit plan</b-link>
      <b-link style="color: #2B5FCB;" @click="editItems" class="ml-3">Edit items</b-link>
    </span>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'WorkPlansEditButtonsRenderer',
  methods: {
    editPlan() {
      this.$store.commit('setPlanToEdit', this.params.data);
    },
    async editItems() {
      await this.$store.dispatch('saveGridOptions', {
        name: 'actions',
        state: this.$store.getters.gridState('actions'),
        sort: this.$store.getters.gridSort('actions'),
        filter: { workPlanName: { values: [this.params.data.name], filterType: 'set' } },
      });

      this.$store.commit('setPlanItemsToEdit', this.params.data);
      this.$router.push({ path: '/actions' });
    },
  },
});
</script>
